import { PRICING_PLANS } from "features/subscriptions/constants";

import { Tag } from "common/components/ui/Tag";
import type { SubscriptionType } from "common/types";

import SubscriptionPlanIcon from "./SubscriptionPlanIcon";

interface SubscriptionPlanProps {
  plan: SubscriptionType;
  isTrial?: boolean;
}

export default function SubscriptionPlan({
  plan,
  isTrial,
}: SubscriptionPlanProps) {
  const { name, description } = PRICING_PLANS[plan];

  return (
    <div className="flex flex-col lg:flex-row gap-5 lg:gap-2.5 px-2">
      <SubscriptionPlanIcon plan={plan} size="sm" />
      <div className="flex flex-col items-start gap-y-1">
        <div className="flex items-center gap-x-1.5">
          <h3 className="text-md-bold">{name}</h3>
          {isTrial && (
            <Tag variant="secondary" size="sm">
              14 day free trial
            </Tag>
          )}
        </div>
        <p className="text-xs-medium text-black-500">{description}</p>
      </div>
    </div>
  );
}
